import { Observer } from "mobx-react";
import { useStores } from "../../store";
import {
  MdFileUpload,
} from "react-icons/md";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { pdfjs } from "react-pdf";
import carrerImg2 from "../../assests/careerImg2.png";
import { apiPostPut } from "../../api/api_methods";
import { getUserDataFromLocalStorage } from "../../services/localStorage";
import Loader from "../reusble_components/loader";
import { useParams } from "react-router-dom";
import HelpCenter from "../reusble_components/helpCenter";

export default function Career() {
  const { tech } = useParams();
  const [Tech, setTech] = useState(tech);
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
  const [resume, setResume] = useState(false);
  const [loading, setLoading] = useState(false);

  const { InterviewStore, RecuiterStore, UserStore } = useStores();
  const [level, setLevel] = useState("");
  const [skills, setSkills] = useState([]);
  const skillInputRef = useRef(null);
  const [showSkills, setShowSkills] = useState(true);
  const studentDetails = JSON.parse(localStorage.getItem("user"));
  const [experiences, setExperiences] = useState([
    {
      company: "",
      designation: "",
      joiningDate: "",
      completionDate: "",
    },
  ]);
  useEffect(() => {
    console.log("tech", tech);
    document.getElementById("technology").value = tech;
  }, [tech]);
  const addSkills = () => {
    setShowSkills(true);
    if (skillInputRef.current.value !== "") {
      setSkills([...skills, skillInputRef.current.value]);
    }

    skillInputRef.current.value = "";
    // setSkills("");
  };

  const removeSkill = (skill) => {
    setSkills(skills.filter((item) => item !== skill));
  };

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const newExperiences = [...experiences];
    newExperiences[index][name] = value;
    setExperiences(newExperiences);
  };

  const handleAddExperience = () => {
    setExperiences([
      ...experiences,
      {
        company: "",
        designation: "",
        joiningDate: "",
        completionDate: "",
      },
    ]);
  };

  const handleDeleteExperience = (index) => {
    const newExperiences = [...experiences];
    newExperiences.splice(index, 1);
    setExperiences(newExperiences);
  };

  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data; // Directly use response.data as array buffer

      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }

      // setExtractedText(fullText);
      console.log(fullText);
      InterviewStore.setResumeText(fullText);
    } catch (error) {
      console.error("Error fetching or parsing PDF file", error);
    }
  };
  const handleFileChange = (event) => {
    const selectedFile = event.currentTarget.files[0];
    const file = event.target.files[0];
    if (!file) {
      // If no file is selected, display an alert
      alert("Please select a PDF file.");
      return;
    }

    if (selectedFile) {
      InterviewStore.setResumeFile(selectedFile);
      const fileURL = URL.createObjectURL(selectedFile);
      fetchData(fileURL);
      setResume(true);
      // const { name } = selectedFile;
      // setSelectedFileName(name); // Update the state with the filename
      // setSelectFileByUser(selectedFile);
    }
  };
  const [formData, setFormData] = useState({});

  // Function to handle form submission
  const handleSubmit = async (event) => {
    // event.preventDefault(); // Prevents default form submission behavior
    // const data={
    //     name:event.target.name.value,
    //     tech:event.target.technology.value,
    //     que:event.target.que.value,
    //     level:event.target.level.value,

    // }
    // console.log("Form submitted with data:", data,skills,experiences );
    console.log("Form submitted with data:");
    event.preventDefault();
    try {
      function searchNameInResumeText() {
        // Split the name by spaces to get an array of name parts

        const nameParts = event.target.name.value
          .split(" ")
          .filter((part) => part.trim() !== "");
        // Check if any of the name parts are included in the InterviewStore.resumeText string
        const isNameFound = nameParts.some((part) =>
          InterviewStore.resumeText.includes(part)
        );
        console.log(nameParts);

        return isNameFound;
      }
      if (true) {
        console.log("mohan");

        console.log(searchNameInResumeText());
        if (!searchNameInResumeText()) {
          alert("Your Name in the Resume should match with the entered name");
          return;
        }
      } // Do something with the matched resumes
    } catch (error) {
      console.error("Error processing interview screen parameters:", error);
    }

    console.log("in interview");

    if (InterviewStore.resumeFile === null) {
      alert("Please upload your resume");
      console.log("Hello", event.target.fileInput.files);
    } else {
      setLoading(true);
      let resumeLink = null;

      const userDetails = await getUserDataFromLocalStorage();

      if (
        userDetails?.role?.role != "company" &&
        userDetails?.role?.role != "consultancy"
      ) {
        // check resume uploaded or not for resume based interview for user or students
        const idOfResumeBasedInterviews = [2, 4, 8];

        if (InterviewStore.resumeFile === null) {
          return alert("Please upload your resume");
        }

        // upload resume to azure cloud storage, but for now we are not using it

        // const resumeFileName = Date.now() + InterviewStore.resumeFile?.name;

        // const resumeUploadResponse = await uploadFileToAzure(
        //   resumeFileName,
        //   InterviewStore.resumeFile,
        //   { action: "interview" }
        // );
        // console.log(resumeUploadResponse);
        // if (resumeUploadResponse?.success) {
        //   resumeLink = resumeUploadResponse?.url;
        // }

        // end of resume upload to azure cloud storage
      }

      let interviewDetails = {
        name: event.target.name.value,
        technology: event.target.technology.value,
        levelOfInterview: event.target.level.value,
        noOfQuestions: event.target.que.value,
        customQuestions: InterviewStore.customQuestions,
        // resume: InterviewStore.resumeFile,
        resume: InterviewStore.resumeText,
      };
      if (resumeLink !== null) {
        interviewDetails["resumeLink"] = resumeLink;
      }

      console.log(userDetails);

      console.log(interviewDetails);
      // alert(interviewDetails);
      // return;

      if (
        userDetails?.role?.role === "company" ||
        userDetails?.role?.role === "consultancy"
      ) {
        // InterviewStore.changeInterviewIdByIdForResume(
        //   InterviewStore.interviewSettings?.id
        // );
        interviewDetails["interviewer"] = userDetails?._id;
        interviewDetails["interviewType"] = "real";
        InterviewStore.updateInterviewDetails(interviewDetails);

        let body = {
          ...InterviewStore.interviewSettings,
          isInvitation: true,
        };

        delete body.id;

        console.log(body);
        if (RecuiterStore.clientId) {
          body.client = RecuiterStore.clientId;
        }

        const apiResponse = await apiPostPut(
          body,
          "/interview/interview-invitation",
          "POST"
        );

        console.log(apiResponse);
        if (apiResponse.body?.success) {
          alert("Invitation sent successfully");

          console.log(apiResponse.body?.data?.interviewLink);
          // setInvitationLink(apiResponse.body?.data?.interviewLink);
        } else {
          alert("Something went wrong");
        }

        return;
      }

      // localStorage.setItem("interviewDetails", JSON.stringify(interviewDetails));
      InterviewStore.updateInterviewDetails(interviewDetails);
      console.log(InterviewStore.interviewDetails);
      // navigate(
      //   `/interview?name=${name}&technology=${technology}&level=${level}&question=${noOfQuestions}&id=${InterviewStore.interviewSettings?.id}`
      // );
      // Construct the new URL
      const interviewsettings = {
        id: 2,
        interviewId: 2,
        levelOfInterview: event.target.level.value,
        model: 3,
        name: event.target.name.value,
        noOfQuestions: event.target.que.value,
        resume: InterviewStore.resumeText,
        resumeLink: resumeLink,

        technology: event.target.technology.value,
        title: "Resume Based Interview",
      };
      console.log(interviewsettings);
      localStorage.setItem(
        "interviewSettings",
        JSON.stringify(interviewsettings)
      );
      const newURL = `/interview?name=${event.target.name.value}&technology=${
        event.target.technology.value
      }&level=${event.target.level.value}&question=${
        event.target.que.value
      }&id=${2}`;
      setLoading(false);

      // Set the new URL and trigger a reload
      window.location.href = newURL;
    }
  };

  // Function to update form data
  const handleChange = (event) => {
    const { name, value } = event.target;
    console.log(value);
    setFormData({ ...formData, [name]: value });
  };
  return (
    <Observer>
      {() => (
        <div className="mt-28 mb-32 md:my-0 ">
          <HelpCenter />
          {
            <div
              // className={`bg-bg3 md:px-10 lg:px-10 px-0  flex flex-col diamond-gradient lg:w-[90vw] md:w-[20vw] w-[100vw] rounded-[50px] md:h-[95vh] lg:h-[95vh] justify-center md:ml-[-95%] lg:ml-[-95%] lg:mt-0 md:mt-0 mt-[300px] transition-transform duration-1000 ease-in-out overflow-y-hidden overflow-x-hidden `}
              className="bg-bg3 md:px-10 flex flex-col mt-12  md:mt-0  md:h-screen md:overflow-hidden  transition-transform duration-1000 ease-in-out  "
            >
              <Loader loader={loading} />
              <div className="flex flex-col md:flex-row lg:flex-row justify-around p-5">
                <div className="pl-2 md:pt-6 p-10 flex flex-col w-[90%] md:w-[50%] md:h-screen overflow-hidden  ">
                  <h1 className="text-2xl md:text-4xl font-extrabold md:mt-24 lg:mt-40 leading-[50px] ">
                    Take <span className="text-primary mt-0">Interview</span>
                    {/* Interview Session */}
                  </h1>
                  <img
                    src={carrerImg2}
                    className="w-72 pt-8 hidden md:block"
                  ></img>
                  <p className="text-base md:text-lg text-[#4E4E4E] mt-5 md:mt-8 ">
                    Efficient Initial Screening: A resume interview efficiently
                    screens candidates based on their resume, providing a quick
                    assessment of qualifications and potential alignment with
                    the job.{" "}
                  </p>
                </div>
                <form
                  className="flex flex-col justify-center  md:pt-4 md:overflow-hidden items-center  md:w-[50%] lg:w-[40%] my-2 lg:ml-0 md:ml-0 ml-5 md:py-3 h-[100%] overflow-y-scroll"
                  onSubmit={(e) => handleSubmit(e)}
                >
                  {/* <h1 className="text-center text-primary text-[30px]">Interview Creation</h1> */}
                  {/* <div className="mr-2 ml-auto ">
                <div className="w-6 h-6 text-lg text-bg3 m-auto cursor-pointer  rounded-full  bg-primary" >
                  <p className="flex justify-center items-center  m-auto"><span className="m-auto">x</span></p>
                </div>
              </div> */}

                  <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                    <label
                      htmlFor="name"
                      className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                    >
                      Candidate Name*
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      defaultValue={
                        UserStore?.userDetails?.name || studentDetails?.name
                      }
                      onChange={handleChange}
                      className="px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] lg:h-[50px] md:text-lg lg:text-xl focus:outline-none "
                    />
                  </div>

                  <div
                    className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                      InterviewStore.maskingFields.includes("technology")
                        ? "pointer-events-none"
                        : ""
                    }`}
                  >
                    <label
                      htmlFor="technology"
                      className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                    >
                      Topic of Interview (Technology)*
                    </label>
                    <input
                      type="text"
                      id="technology"
                      defaultValue={tech}
                      value={Tech}
                      required
                      name="technology"
                      onChange={(e) => setTech(e.target.value)}
                      //   value={technology}
                      //   onChange={handlechangeTechnology}
                      className=" px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] lg:h-[50px] md:text-lg lg:text-xl focus:outline-none "
                    />
                  </div>

                  <div
                    className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                      InterviewStore.maskingFields.includes("noOfQuestions")
                        ? "pointer-events-none"
                        : ""
                    }`}
                  >
                    <label
                      htmlFor="technology"
                      className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                    >
                      Select No of questions
                    </label>
                    <select
                      className=" px-5 py-3 rounded-xl w-[95%] h-[45px] md:h-[45px] lg:h-[50px] md:text-lg lg:text-xl text-primary border text-center border-primary  focus:outline-none "
                      name="que"
                      //   value={noOfQuestions}
                      //   onChange={(e) => setnoOfQuestions(e.target.value)}
                      onChange={handleChange}
                    >
                      <option defaultChecked={true} value={5}>
                        5 Questions
                      </option>
                      <option value={10}>10 Questions</option>
                    </select>
                  </div>

                  <div
                    className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                      InterviewStore.maskingFields.includes("interviewLevel")
                        ? "pointer-events-none"
                        : ""
                    }`}
                  >
                    <label
                      htmlFor="level"
                      className="block mt-2 mb-1 ml-2 font-medium md:text-base lg:text-lg"
                      //   onDoubleClick={handleModal}
                    >
                      Select Level
                    </label>
                    <select
                      className=" px-5 py-3 rounded-xl w-[95%] h-[45px] md:h-[45px] lg:h-[50px] md:text-lg lg:text-xl text-primary border text-center border-primary  focus:outline-none "
                      name="level"
                      //   value={level}
                      //   onChange={(e) => setLevel(e.target.value)}
                      onChange={handleChange}
                    >
                      <option defaultChecked={true} value="low">
                        Low
                      </option>
                      <option value="medium">Medium</option>
                      <option value="high">High</option>
                    </select>
                  </div>

                  <div
                    className={`mb-1 md:mt-2 w-[100%] pr-5 flex flex-row items-center justify-between md:w-[70%] lg:w-[65%] ${
                      InterviewStore.maskingFields.includes("askHaveResume")
                        ? "pointer-events-none"
                        : ""
                    }`}
                  >
                    <label
                      htmlFor="level"
                      className="block text-center items-center md:ml-2 font-medium md:text-base lg:text-lg"
                      // onDoubleClick={handleModal}
                    >
                      Attach your resume
                    </label>
                  </div>

                  <div className="my-2  w-full md:w-[70%] lg:w-[63%]">
                    <div className="flex flex-col">
                      <input
                        id="fileInput"
                        name="fileInput"
                        type="file"
                        className="hidden"
                        onChange={handleFileChange}
                        accept=".pdf"
                      />
                      <label
                        htmlFor="fileInput"
                        className={`px-5 py-1 w-[78%] min-w-[99%]  text-center flex items-center border lg:gap border-primary rounded-xl cursor-pointer  transition duration-300 ease-in-out ${
                          InterviewStore.showResume
                            ? "gap-1 justify-center"
                            : "gap-2 "
                        }`}
                      >
                        <p className="font-semibold text-sm">
                          {InterviewStore.resumeFile?.name}
                        </p>{" "}
                        <div
                          className={`flex  items-center  h-[35px] md:text-lg lg:text-xl ${
                            InterviewStore.showResume ? "gap-1" : "gap-2"
                          }`}
                        >
                          <MdFileUpload className="text-primary text-2xl" />{" "}
                          Upload
                        </div>
                      </label>
                      {/* {selectedFileName && (
                            <p className="text-blue-500">{selectedFileName}</p>
                          )} */}
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="w-[70%] lg:w-[63%] px-5  py-3 lg:py-4 mt-4 bg-primary text-white rounded-md shadow-md hover:bg-primary-dark focus:outline-none"
                  >
                    Create an Interview
                  </button>
                </form>
              </div>
            </div>
          }
        </div>
      )}
    </Observer>
  );
}
